module.exports = __webpack_public_path__ + "static/media/chicken_hero.28862d45.jpg";